import { createAction } from '@reduxjs/toolkit';

export const SetWishlistItems = createAction('wishlist/set_items');
